/* TwentySix product page (sections/ts-product.liquid) */
(function () {
  'use strict';

  var ROOT_DIR = (document.documentElement.getAttribute('dir') || getComputedStyle(document.documentElement).direction || 'ltr').toLowerCase();
  var RTL = ROOT_DIR === 'rtl';
  var SIZE_KEY = 'tsPdpSize';
  var ICON_X = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5.5 5.5l13 13M18.5 5.5l-13 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var ICON_R = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_L = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function hdr() {
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height'));
    return isNaN(v) ? 0 : v;
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function raf(fn) { return (window.requestAnimationFrame || setTimeout)(fn); }
  function norm(t) { return String(t == null ? '' : t).replace(/\s+/g, '').toUpperCase(); }

  /* ---------- other colours without leaving the page ----------
     Each colour is its own product (combined listing). Clicking a colour fetches that product's sections
     (Section Rendering API), swaps them in place and updates the address, so the shopper stays where she is.
     Colours are fetched ahead of time (idle + hover/touch), so the swap is instant. Any failure = normal link. */
  var SWAP = { cache: {}, token: null, done: false };
  var CAN_SWAP = !!(window.fetch && window.DOMParser && window.history && history.pushState && window.URL);
  function titleOf(root) {
    var h = root && root.querySelector('.ts-pdp__title');
    return h ? h.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function secId(el) {
    var s = el && el.closest('.shopify-section');
    return s && s.id ? s.id.replace(/^shopify-section-/, '') : '';
  }
  function swapTarget(href) {
    var u = new URL(href, location.href);
    var m = location.pathname.match(/^(\/collections\/[^/]+)\/products\//);
    if (m && u.pathname.indexOf('/collections/') !== 0) u.pathname = m[1] + u.pathname;
    u.search = '';
    u.hash = '';
    return u;
  }
  function warmImage(html) {
    try {
      var c = navigator.connection;
      if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
      var m = html.match(/<img[^>]+class="ts-pdp__img"[^>]*>/) || html.match(/<figure class="ts-pdp__slide"[\s\S]*?<img[^>]*>/);
      if (!m) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = m[0].replace(/^[\s\S]*(<img)/, '$1');
      var src = tmp.querySelector('img');
      if (!src) return;
      var im = new Image();
      if (src.getAttribute('sizes')) im.sizes = src.getAttribute('sizes');
      if (src.getAttribute('srcset')) im.srcset = src.getAttribute('srcset');
      im.src = src.getAttribute('src');
    } catch (e) {}
  }
  function loadProduct(href) {
    var u = swapTarget(href);
    var key = u.pathname;
    if (SWAP.cache[key]) return SWAP.cache[key];
    var ids = [];
    each(document.querySelectorAll('[data-ts-pdp],[data-ts-more]'), function (el) { var id = secId(el); if (id) ids.push(id); });
    var f = new URL(u.href);
    f.searchParams.set('sections', ids.join(','));
    var pt = new URLSearchParams(location.search).get('preview_theme_id');
    if (pt) f.searchParams.set('preview_theme_id', pt);
    var p = fetch(f.href, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function (j) {
        var main = j && j[secId(document.querySelector('[data-ts-pdp]'))];
        if (!main || main.indexOf('data-ts-pdp') < 0) throw new Error('template');
        warmImage(main);
        return j;
      });
    p.catch(function () { delete SWAP.cache[key]; });
    SWAP.cache[key] = p;
    return p;
  }
  function swapProduct(href, opts) {
    opts = opts || {};
    var oldRoot = document.querySelector('[data-ts-pdp]');
    if (!CAN_SWAP || !oldRoot) { location.href = href; return; }
    var token = {};
    SWAP.token = token;
    var oldGrid = oldRoot.querySelector('.ts-pdp__grid');
    var slow = setTimeout(function () {
      if (!oldGrid) return;
      oldGrid.style.transition = 'opacity .2s ease';
      oldGrid.style.opacity = '.5';
      oldGrid.style.pointerEvents = 'none';
    }, 140);
    var target = swapTarget(href);
    loadProduct(href).then(function (j) {
      if (SWAP.token !== token) return;
      clearTimeout(slow);
      var mainId = secId(oldRoot);
      var doc = new DOMParser().parseFromString(j[mainId], 'text/html');
      var newRoot = doc.querySelector('[data-ts-pdp]');
      if (!newRoot) throw new Error('markup');
      var y = window.pageYOffset;
      var wrap = oldRoot.closest('.shopify-section');

      /* colour picked inside the branch panel: the new panel reuses the photos already on screen and keeps its scroll, so nothing blinks */
      var keepImgs = [], keepScroll = 0;
      if (opts.openBs) {
        each(document.querySelectorAll('[data-bs-colors] img'), function (im) { keepImgs.push(im); });
        var oldBody = document.querySelector('[data-bs] .ts-sg__body');
        if (oldBody) keepScroll = oldBody.scrollTop;
      }
      if (oldRoot.__tsDestroy) oldRoot.__tsDestroy();
      newRoot.__tsCarry = { size: opts.size || null, openBs: !!opts.openBs, imgs: keepImgs, scroll: keepScroll };
      oldRoot.replaceWith(newRoot);

      /* product structured data */
      var oldLd = wrap ? wrap.querySelectorAll('script[type="application/ld+json"]:not(.ts-pdp script)') : [];
      var newLd = doc.querySelectorAll('script[type="application/ld+json"]:not(.ts-pdp script)');
      each(oldLd, function (s) { s.remove(); });
      each(newLd, function (s) { wrap.appendChild(s); });

      /* app blocks (Tellos video) start their own scripts again for the new product */
      each(newRoot.querySelectorAll('.ts-pdp__app script'), function (s) {
        if (s.type && !/javascript|module/.test(s.type)) return;
        var n = document.createElement('script');
        each(s.attributes, function (a) { n.setAttribute(a.name, a.value); });
        n.textContent = s.textContent;
        s.replaceWith(n);
      });
      /* the video carousel mounts once per page load: run it again so it shows this colour's videos */
      var tls = document.querySelector('script[src*="tellos-carousel"]');
      if (tls && newRoot.querySelector('#tellos-carousel')) {
        var tn = document.createElement('script');
        tn.src = tls.src;
        tn.async = true;
        tls.remove();
        document.body.appendChild(tn);
      }

      init(newRoot);
      newRoot.__tsPath = target.pathname;

      /* complete the look / you may also like / recently viewed */
      var moreOld = document.querySelector('[data-ts-more]');
      var moreHtml = moreOld && j[secId(moreOld)];
      if (moreHtml) {
        var md = new DOMParser().parseFromString(moreHtml, 'text/html');
        var moreNew = md.querySelector('[data-ts-more]');
        if (moreNew) { moreOld.replaceWith(moreNew); initMore(moreNew); }
      }

      /* address, title, wishlist hearts */
      var newTitle = titleOf(newRoot);
      var url = target.pathname;
      var vid = newRoot.__tsVariant ? newRoot.__tsVariant() : null;
      if (vid) url += '?variant=' + vid;
      if (opts.push !== false) history.pushState({ tsPdp: 1 }, '', url);
      else history.replaceState(history.state, '', url + location.hash);
      if (SWAP.title && newTitle && document.title.indexOf(SWAP.title) > -1) document.title = document.title.replace(SWAP.title, newTitle);
      if (newTitle) SWAP.title = newTitle;
      if (window.TSWishlist && typeof TSWishlist.refresh === 'function') { try { TSWishlist.refresh(); } catch (e) {} }

      if (Math.abs(window.pageYOffset - y) > 1) window.scrollTo(0, y);
      SWAP.done = true;
      document.dispatchEvent(new CustomEvent('ts:product:swapped', { detail: { url: url, handle: target.pathname.split('/').pop() } }));
      prefetchSiblings(newRoot);
    }).catch(function () {
      if (SWAP.token === token) location.href = href;
    });
  }
  function prefetchSiblings(root) {
    if (!CAN_SWAP) return;
    var links = Array.prototype.slice.call(root.querySelectorAll('a[data-sibling]'), 0, 6);
    if (!links.length) return;
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
    idle(function () {
      links.forEach(function (a, i) { setTimeout(function () { loadProduct(a.href).catch(function () {}); }, i * 250); });
    });
  }
  if (CAN_SWAP) {
    window.addEventListener('popstate', function () {
      var root = document.querySelector('[data-ts-pdp]');
      if (!root || !root.__tsPath || !SWAP.done && !(history.state && history.state.tsPdp)) return;
      if (location.pathname === root.__tsPath) return;
      if (!/\/products\//.test(location.pathname)) { location.reload(); return; }
      swapProduct(location.href, { push: false });
    });
  }

  /* ---------- horizontal rails (arrows on desktop, swipe on phones) ---------- */
  function initRail(rail) {
    if (rail.__tsRail) { rail.__tsRail(); return; }
    var tr = rail.querySelector('[data-rail-track]');
    var prev = rail.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]');
    if (!tr) return;
    function paint() {
      var max = tr.scrollWidth - tr.clientWidth;
      var pos = Math.abs(tr.scrollLeft);
      rail.classList.toggle('no-scroll', max < 4);
      if (prev) prev.disabled = pos < 4;
      if (next) next.disabled = pos > max - 4;
    }
    function go(dir) {
      var item = tr.firstElementChild;
      var gap = parseFloat(getComputedStyle(tr).columnGap) || 0;
      var w = item ? item.getBoundingClientRect().width + gap : tr.clientWidth;
      var per = Math.max(1, Math.floor((tr.clientWidth + gap) / w));
      tr.scrollBy({ left: (RTL ? -1 : 1) * dir * per * w, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    tr.addEventListener('scroll', function () { raf(paint); }, { passive: true });
    window.addEventListener('resize', paint);
    rail.__tsRail = paint;
    paint();
  }

  /* ---------- after the product: you may also like + recently viewed ---------- */
  var RECENT_KEY = 'tsRecent';
  function initMore(more) {
    if (more.__tsMore) return;
    more.__tsMore = true;
    var pid = String(more.getAttribute('data-product-id') || '');
    var handle = more.getAttribute('data-handle') || '';
    var shown = {};
    if (pid) shown[pid] = true;
    function idOf(el) {
      var b = el.matches && el.matches('[data-product-id]') ? el : el.querySelector('[data-product-id]');
      return b ? String(b.getAttribute('data-product-id')) : '';
    }
    each(more.querySelectorAll('.ts-more__item'), function (it) { var id = idOf(it); if (id) shown[id] = true; });
    each(more.querySelectorAll('[data-rail]:not([hidden])'), initRail);

    function fill(block, cards, max) {
      var tr = block.querySelector('[data-rail-track]');
      var n = 0;
      cards.forEach(function (card) {
        if (n >= max) return;
        var id = idOf(card);
        if (!id || shown[id]) return;
        shown[id] = true;
        var it = document.createElement('div');
        it.className = 'ts-more__item';
        it.appendChild(card);
        tr.appendChild(it);
        n++;
      });
      if (!n) return;
      block.hidden = false;
      initRail(block);
      document.dispatchEvent(new CustomEvent('ts:cards:added', { detail: { container: block } }));
      if (window.theme && typeof theme.initAnimateOnScroll === 'function') { try { theme.initAnimateOnScroll(); } catch (e) {} }
    }
    var styled = !!document.querySelector('product-block');
    function cardsFrom(html) {
      var box = document.createElement('div');
      box.innerHTML = html;
      var out = [];
      /* the card's own styles (quick add icon) ride along with the first card */
      if (!styled) { var st = box.querySelector('style'); if (st) { more.appendChild(st); styled = true; } }
      each(box.querySelectorAll('product-block'), function (b) { if (!b.parentElement.closest('product-block')) out.push(b); });
      if (!out.length) each(box.querySelectorAll('.product-block'), function (b) { if (!b.parentElement.closest('.product-block')) out.push(b); });
      return out;
    }

    /* recently viewed (this browser only) */
    var recent = [];
    try { recent = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]') || []; } catch (e) { recent = []; }
    if (!Array.isArray(recent)) recent = [];
    var others = recent.filter(function (h) { return h && h !== handle; });
    if (handle) {
      try { localStorage.setItem(RECENT_KEY, JSON.stringify([handle].concat(others).slice(0, 12))); } catch (e) {}
    }

    var recs = more.querySelector('[data-recs]');
    var recentBlock = more.querySelector('[data-recent]');
    var recsDone = recs ? fetch(more.getAttribute('data-recs-url'))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) { if (html) fill(recs, cardsFrom(html), 12); })
      .catch(function () {}) : Promise.resolve();

    if (recentBlock && others.length) {
      var max = parseInt(more.getAttribute('data-recent-max'), 10) || 8;
      var list = others.slice(0, max + 2);
      Promise.all(list.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '?section_id=ts-card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (htmls) {
        var cards = [];
        htmls.forEach(function (html) { if (html) cards = cards.concat(cardsFrom(html).slice(0, 1)); });
        /* recently viewed wins over "you may also like" for the same product, so wait for both */
        return recsDone.then(function () { fill(recentBlock, cards, max); });
      });
    }
  }

  function init(root) {
    if (root.__tsPdp) return;
    root.__tsPdp = true;

    var data;
    try { data = JSON.parse(root.querySelector('[data-ts-pdp-json]').textContent); } catch (e) { return; }
    /* everything this page attaches outside itself is removed when another colour is swapped in */
    var ac = typeof AbortController === 'function' ? new AbortController() : null;
    var L = ac ? { signal: ac.signal } : false;
    var LP = ac ? { signal: ac.signal, passive: true } : { passive: true };
    var io = null, ro = null;
    root.__tsPath = location.pathname;
    if (!SWAP.title) SWAP.title = titleOf(root);
    var T = data.t || {};
    var variants = data.variants || [];
    var nOpts = (data.options || []).length;
    var sizeIndex = typeof data.sizeIndex === 'number' ? data.sizeIndex : -1;
    var threshold = data.low || 3;

    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-opt]'));
    var form = root.querySelector('form[data-ts-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var atc = root.querySelector('[data-atc]');
    var atcTxt = root.querySelector('[data-atc-txt]');
    var heart = root.querySelector('.ts-pdp__heart');
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var priceOff = root.querySelector('[data-price-off]');
    var lowEl = root.querySelector('[data-low]');
    var errEl = root.querySelector('[data-err]');
    var info = root.querySelector('[data-info]');
    var buyRow = root.querySelector('[data-buy]');
    var stEls = Array.prototype.slice.call(root.querySelectorAll('[data-st]'));
    var mqDesk = window.matchMedia('(min-width: 1024px)');
    var mqTab = window.matchMedia('(min-width: 750px)');
    var hasRR = !!document.getElementById('restock-rocket');
    if (hasRR) document.documentElement.classList.add('ts-pdp-notify');

    /* ---------- selection state ---------- */
    var sel = [];
    for (var s = 0; s < nOpts; s++) sel.push(null);
    opts.forEach(function (o) {
      var b = o.querySelector('[data-value].is-sel');
      sel[+o.getAttribute('data-index')] = b ? b.getAttribute('data-value') : null;
    });

    function optEl(i) {
      for (var k = 0; k < opts.length; k++) if (+opts[k].getAttribute('data-index') === i) return opts[k];
      return null;
    }
    function matches(v, skip) {
      for (var i = 0; i < nOpts; i++) {
        if (i === skip || sel[i] == null) continue;
        if (v.o[i] !== sel[i]) return false;
      }
      return true;
    }
    function missing() {
      for (var i = 0; i < nOpts; i++) if (sel[i] == null) return i;
      return -1;
    }
    function current() {
      if (!nOpts) return variants[0] || null;
      if (missing() > -1) return null;
      for (var k = 0; k < variants.length; k++) if (matches(variants[k])) return variants[k];
      return null;
    }
    function closest() {
      var k;
      for (k = 0; k < variants.length; k++) if (variants[k].a && matches(variants[k])) return variants[k];
      for (k = 0; k < variants.length; k++) if (matches(variants[k])) return variants[k];
      return variants[0] || null;
    }

    function refreshAvailability() {
      opts.forEach(function (o) {
        var i = +o.getAttribute('data-index');
        each(o.querySelectorAll('[data-value]'), function (b) {
          var val = b.getAttribute('data-value');
          var exists = false, avail = false;
          for (var k = 0; k < variants.length; k++) {
            var v = variants[k];
            if (v.o[i] !== val || !matches(v, i)) continue;
            exists = true;
            if (v.a) { avail = true; break; }
          }
          b.classList.toggle('is-soldout', !avail);
          b.classList.toggle('is-na', !exists && b.classList.contains('ts-pdp__btn'));
        });
      });
    }

    function stateFor(v) {
      var m = missing();
      if (m > -1) return data.available || hasRR ? 'choose' : 'soldout';
      if (!v) return 'unavailable';
      if (v.a) return 'add';
      return hasRR ? 'notify' : 'soldout';
    }
    /* sold out size: the button opens the back-in-stock form (Restock Rocket) instead of being a dead end */
    function notify() {
      if (SWAP.done) {
        /* after a colour swap the address often differs only by the hash, which never reloads: reload on purpose */
        var v = current();
        try { history.replaceState(null, '', location.pathname + (v ? '?variant=' + v.id : '') + '#ts-notify'); } catch (e) {}
        location.reload();
        return;
      }
      /* STOQ adds its own (hidden) button only after its script has loaded and checked the product, which can take a few
         seconds on a slow connection: wait for it with the button dimmed, and if it never comes, reload once on this
         exact variant (STOQ always draws its button on a fresh load) before showing an error */
      if (notifyWait) return;
      var v = current(), tries = 0;
      notifyWait = true;
      hideErr();
      waitLook(true);
      (function attempt() {
        var b = document.querySelector('.restock-rocket-button-product');
        if (b) {
          notifyWait = false;
          waitLook(false);
          try { sessionStorage.removeItem('tsNotifyRetry'); } catch (e) {}
          b.click();
          pickVariant(v);
          return;
        }
        if (++tries < 40) { setTimeout(attempt, 200); return; }
        notifyWait = false;
        var retried = false;
        try { retried = sessionStorage.getItem('tsNotifyRetry') === location.pathname; } catch (e) { retried = true; }
        if (!retried) {
          try {
            sessionStorage.setItem('tsNotifyRetry', location.pathname);
            history.replaceState(null, '', location.pathname + (v ? '?variant=' + v.id : '') + '#ts-notify');
          } catch (e) {}
          location.reload();
          return;
        }
        try { sessionStorage.removeItem('tsNotifyRetry'); } catch (e) {}
        waitLook(false);
        showErr(T.error);
      })();
    }
    var notifyWait = false;
    function waitLook(on) {
      [atc, barBtn].forEach(function (b) {
        if (!b) return;
        b.style.opacity = on ? '.55' : '';
        b.style.cursor = on ? 'progress' : '';
        if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
      });
    }
    /* make sure STOQ's form signs her up for the variant on the page, not the one STOQ picked by itself */
    function pickVariant(v) {
      if (!v) return;
      var n = 0;
      (function set() {
        var f = document.getElementById('form-Select');
        if (!f) { if (++n < 15) setTimeout(set, 100); return; }
        var id = String(v.id);
        for (var i = 0; i < f.options.length; i++) {
          if (f.options[i].value === id || f.options[i].value.split('/').pop() === id) {
            if (f.selectedIndex !== i) {
              f.selectedIndex = i;
              f.dispatchEvent(new Event('change', { bubbles: true }));
            }
            return;
          }
        }
      })();
    }
    function label(state) {
      if (state === 'choose') {
        var m = missing();
        if (m !== sizeIndex) {
          var o = optEl(m);
          var n = o ? o.querySelector('.ts-pdp__opt-name') : null;
          if (n) return (T.chooseOpt || '') + ' ' + n.textContent.trim();
        }
        return T.choose;
      }
      return T[state] || '';
    }

    /* ---------- render ---------- */
    function update(how) {
      how = how || {};
      refreshAvailability();
      var v = current();
      var shown = v || closest();
      var state = stateFor(v);

      opts.forEach(function (o) {
        var i = +o.getAttribute('data-index');
        each(o.querySelectorAll('[data-value]'), function (b) {
          var on = b.getAttribute('data-value') === sel[i];
          b.classList.toggle('is-sel', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var out = o.querySelector('[data-opt-val]');
        if (out && !o.hasAttribute('data-linked')) {
          /* the chosen colour's button carries its Hebrew name in `title`; sizes have none */
          var selBtn = o.querySelector('[data-value].is-sel');
          out.textContent = sel[i] == null ? '' : ((selBtn && selBtn.getAttribute('title')) || sel[i]);
        }
        if (sel[i] != null) o.classList.remove('is-need');
      });

      if (shown && priceNow) {
        var sale = shown.c > shown.p;
        priceNow.innerHTML = shown.pf;
        priceNow.classList.toggle('is-sale', sale);
        if (priceWas) { priceWas.hidden = !sale; if (sale) priceWas.innerHTML = shown.cf; }
        if (priceOff) { priceOff.hidden = !sale; if (sale) priceOff.textContent = '-' + Math.round((shown.c - shown.p) * 100 / shown.c) + '%'; }
      }

      if (idInput && shown) {
        var newId = String((v || shown).id);
        if (idInput.value !== newId) {
          idInput.value = newId;
          if (how.user) idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (atc) {
        atc.setAttribute('data-state', state);
        atc.disabled = state === 'soldout' || state === 'unavailable';
        if (!atc.classList.contains('is-added')) atcTxt.textContent = label(state);
      }

      if (lowEl) {
        var low = !!(v && v.a && v.q != null && v.q > 0 && v.q <= threshold);
        lowEl.hidden = !low;
        if (low) lowEl.textContent = v.q === 1 ? 'יחידה אחרונה באתר' : 'נשארו רק ' + v.q + ' במלאי באתר';
      }

      if (heart && v) heart.setAttribute('data-v', v.id);

      if (stEls.length && sizeIndex > -1) paintSizeRow(sel[sizeIndex]);

      if (how.user && v) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', u.toString());
        } catch (e) {}
      }

      if (how.user && how.type === 'color' && shown) {
        if (!showColour(shown.o[colorIndex], true) && shown.m) goToMedia(shown.m, true);
      }

      syncBar(state);
      paintBs();
      root.dispatchEvent(new CustomEvent('ts:variant:change', { bubbles: true, detail: { variant: v } }));
    }

    /* the chosen size, highlighted in the size tables (rows, or columns when sizes run across) */
    function paintSizeRow(size) {
      var want = norm(size);
      stEls.forEach(function (box) {
        each(box.querySelectorAll('.is-sel'), function (el) { el.classList.remove('is-sel'); });
        if (!want) return;
        var rows = box.querySelectorAll('tr');
        var hit = false;
        each(rows, function (tr) {
          var c = tr.cells[0];
          if (!hit && c && norm(c.textContent) === want) { tr.classList.add('is-sel'); hit = true; }
        });
        if (hit || !rows.length) return;
        var head = rows[0].cells, col = -1;
        for (var k = 1; k < head.length; k++) if (norm(head[k].textContent) === want) { col = k; break; }
        if (col < 0) return;
        each(rows, function (tr) { if (tr.cells[col]) tr.cells[col].classList.add('is-sel'); });
      });
    }

    function hideErr() { if (errEl) { errEl.hidden = true; errEl.textContent = ''; } }
    function showErr(msg) { if (errEl) { errEl.textContent = msg || T.error; errEl.hidden = false; } }

    function inView(el, pad) {
      var r = el.getBoundingClientRect();
      return r.top >= hdr() + (pad || 0) && r.bottom <= window.innerHeight - 80;
    }
    /* where an element of the details column really sits on the page (the column is sticky on desktop,
       so its on-screen position is not its page position) */
    function pageTop(el) {
      if (mqDesk.matches && info && info.contains(el)) {
        var grid = root.querySelector('.ts-pdp__grid');
        return grid.getBoundingClientRect().top + window.pageYOffset + (el.getBoundingClientRect().top - info.getBoundingClientRect().top);
      }
      return el.getBoundingClientRect().top + window.pageYOffset;
    }
    /* scroll so el sits `gap` px under the header, then check once more (the header can slide back in mid-scroll) */
    function bringTo(el, gap) {
      var go = function (smooth) {
        var y = Math.max(0, pageTop(el) - hdr() - gap);
        if (Math.abs(window.pageYOffset - y) > 2) window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' });
      };
      go(true);
      setTimeout(function () {
        var off = el.getBoundingClientRect().top - hdr() - gap;
        if (Math.abs(off) > 24 && !(mqDesk.matches && info.contains(el))) go(true);
      }, 750);
    }
    function nudge() {
      var o = optEl(missing());
      if (!o) return;
      o.classList.remove('is-need');
      void o.offsetWidth;
      o.classList.add('is-need');
      if (inView(o, 8)) return;
      bringTo(o, mqDesk.matches ? 32 : 20);
    }

    /* opening a tab scrolls the page so what opened is in view */
    each(root.querySelectorAll('.ts-acc'), function (d) {
      var sum = d.querySelector('summary');
      if (sum) sum.addEventListener('click', function () { d.__tsUser = Date.now(); });
      d.addEventListener('toggle', function () {
        /* only when the shopper opened it (a tab that starts open also fires "toggle" while the page loads) */
        if (!d.open || !d.__tsUser || Date.now() - d.__tsUser > 1500) return;
        d.__tsUser = 0;
        setTimeout(function () {
          /* if what opened doesn't fit on screen, bring its title up to just under the header */
          var r = d.getBoundingClientRect();
          var room = window.innerHeight - (mqDesk.matches ? 16 : 90);
          if (r.bottom <= room && r.top >= hdr()) return;
          bringTo(d, 12);
        }, 60);
      });
    });

    /* ---------- clicks ---------- */
    root.addEventListener('click', function (e) {
      var t = e.target;
      var b = t.closest ? t.closest('[data-value]') : null;
      if (b && root.contains(b)) {
        var o = b.closest('[data-opt]');
        if (!o) return;
        var i = +o.getAttribute('data-index');
        sel[i] = b.getAttribute('data-value');
        hideErr();
        update({ user: true, type: o.getAttribute('data-type') });
        return;
      }
      var bo = t.closest ? t.closest('[data-bs-open]') : null;
      if (bo && bs) { openBs(bo); return; }
      var g = t.closest ? t.closest('[data-guide]') : null;
      if (g) {
        if (sg) { openSg(g); return; }
        var acc = root.querySelector('[data-size-acc]');
        if (acc) { acc.open = true; acc.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        return;
      }
      var sib = t.closest ? t.closest('a[data-sibling]') : null;
      if (sib) {
        var size = sizeIndex > -1 ? sel[sizeIndex] : null;
        if (CAN_SWAP && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0)) {
          e.preventDefault();
          /* the tapped colour answers at once, the rest follows when the product is in */
          var row = sib.closest('[data-opt]');
          if (row) {
            each(row.querySelectorAll('.ts-sw, .ts-pdp__btn--txt'), function (x) { x.classList.toggle('is-sel', x === sib); });
            var out = row.querySelector('[data-opt-val]');
            if (out && sib.getAttribute('title')) out.textContent = sib.getAttribute('title');
          }
          swapProduct(sib.href, { size: size });
          return;
        }
        if (size) { try { sessionStorage.setItem(SIZE_KEY, size); } catch (x) {} }
      }
    });

    /* fetch the other colours ahead of time so switching is instant */
    var prefetched = {};
    function prefetch(a) {
      var href = a.getAttribute('href');
      if (!href || prefetched[href]) return;
      prefetched[href] = true;
      if (CAN_SWAP) { loadProduct(href).catch(function () {}); return; }
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = href;
      document.head.appendChild(l);
    }
    each(root.querySelectorAll('a[data-sibling]'), function (a) {
      a.addEventListener('pointerenter', function () { prefetch(a); });
      a.addEventListener('touchstart', function () { prefetch(a); }, { passive: true });
    });

    /* ---------- size guide (side panel on desktop, bottom sheet on phones) ---------- */
    var sg = root.querySelector('[data-sg]');
    var sgOpener = null;
    if (sg) {
      document.body.appendChild(sg);
      sg.addEventListener('click', function (e) { if (e.target.closest('[data-sg-close]')) closeSg(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sg.hidden) closeSg(); }, L);
      window.addEventListener('popstate', function () { if (!sg.hidden) closeSg(true); }, L);
    }
    function openSg(opener) {
      sgOpener = opener || null;
      sg.hidden = false;
      try { window.history.pushState({ tsSg: 1 }, ''); } catch (e) {}
      document.documentElement.classList.add('ts-sg-open');
      raf(function () {
        raf(function () {
          sg.classList.add('is-open');
          var c = sg.querySelector('.ts-sg__close');
          if (c) c.focus({ preventScroll: true });
        });
      });
    }
    function closeSg(fromHistory) {
      if (!sg || sg.hidden) return;
      if (fromHistory !== true && window.history.state && window.history.state.tsSg) { window.history.back(); return; }
      sg.classList.remove('is-open');
      document.documentElement.classList.remove('ts-sg-open');
      setTimeout(function () { sg.hidden = true; }, 350);
      if (sgOpener) sgOpener.focus({ preventScroll: true });
    }

    /* ---------- stock in the branches ----------
       Numbers per variant come from the metafield custom.branch_stock ({locationId: {name, available}}), which Shopify Flow
       rewrites on every inventory change. The page carries them, and the panel asks for them again each time it opens. */
    var BS = data.bs || null;
    var bs = BS ? root.querySelector('[data-bs]') : null;
    var bsLine = root.querySelector('[data-bs-line]');
    var bsOpener = null, bsSeq = 0;
    if (bs) {
      document.body.appendChild(bs);
      bs.addEventListener('click', function (e) {
        if (e.target.closest('[data-bs-close]')) { closeBs(); return; }
        var b = e.target.closest('[data-bs-size]');
        if (b) { pickSize(b.getAttribute('data-bs-size')); return; }
        var cw = e.target.closest('[data-bs-colors]');
        if (!cw) return;
        var sib = e.target.closest('a[data-sibling]');
        if (sib) {
          e.preventDefault();
          if (!CAN_SWAP) { location.href = sib.href; return; }
          each(cw.querySelectorAll('.ts-sw, .ts-pdp__btn--txt'), function (x) { x.classList.toggle('is-sel', x === sib); });
          swapProduct(sib.href, { size: sizeIndex > -1 ? sel[sizeIndex] : null, openBs: true });
          return;
        }
        var cv = e.target.closest('[data-value]');
        if (cv) {
          var o = optEl(+(root.querySelector('.ts-pdp__opt--color') || {}).getAttribute('data-index'));
          if (!o) return;
          each(o.querySelectorAll('[data-value]'), function (x) { if (x.getAttribute('data-value') === cv.getAttribute('data-value')) x.click(); });
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !bs.hidden) closeBs(); }, L);
      window.addEventListener('popstate', function () { if (!bs.hidden) closeBs(true); }, L);
    }
    function bsQty(vid, loc) {
      var m = BS && BS.v ? BS.v[vid] : null;
      var e = m ? m[loc] : null;
      var q = e ? +e.available : 0;
      return q > 0 ? q : 0;
    }
    function bsPlace(n) { return 'ב' + String(n || '').replace(/^סניף\s+/, ''); }
    function bsJoin(list) {
      if (list.length < 2) return list[0] || '';
      return list.slice(0, -1).join(', ') + ' ו' + list[list.length - 1];
    }
    /* the variant to answer for: the chosen size (or the only variant); null = no size chosen yet */
    function bsTarget() {
      if (sizeIndex < 0) return current() || (variants.length === 1 ? variants[0] : null);
      return sel[sizeIndex] ? current() : null;
    }
    function bsPool(v) {
      return v ? [v] : variants.filter(function (x) { return matches(x, sizeIndex); });
    }
    /* a one-size product with colours: the line names the colour ("צבע תכלת במלאי...") instead of "מידה One Size" */
    var bsSizeVals = {};
    if (sizeIndex > -1) variants.forEach(function (x) { bsSizeVals[x.o[sizeIndex]] = 1; });
    var bsOneSize = sizeIndex > -1 && Object.keys(bsSizeVals).length === 1;
    function bsColor() {
      var el = root.querySelector('.ts-pdp__opt--color [data-opt-val]');
      return el ? el.textContent.trim() : '';
    }
    var bsColors = bs ? bs.querySelector('[data-bs-colors]') : null;
    function paintBsColors() {
      if (!bsColors) return;
      var src = root.querySelector('.ts-pdp__opt--color .ts-pdp__vals');
      if (!src || src.children.length < 2) { bsColors.innerHTML = ''; bsColors.__sig = null; bsColors.hidden = true; if (bsColors.previousElementSibling) bsColors.previousElementSibling.hidden = true; return; }
      /* the panel repaints often (open, every size, fresh stock numbers): rebuild the colours only when they changed,
         and move the photos already shown into the new row instead of loading them again (that was the double blink) */
      var sig = src.innerHTML;
      if (bsColors.__sig !== sig || !bsColors.firstChild) {
        var have = {};
        var keep = Array.prototype.slice.call(bsColors.querySelectorAll('img'));
        if (root.__tsCarry && root.__tsCarry.imgs) { keep = keep.concat(root.__tsCarry.imgs); root.__tsCarry.imgs = null; }
        keep.forEach(function (im) { var k = im.getAttribute('src'); if (k && !have[k]) have[k] = im; });
        var c = src.cloneNode(true);
        c.removeAttribute('role');
        each(c.querySelectorAll('img'), function (im) {
          var k = im.getAttribute('src'), o = have[k];
          if (o) { delete have[k]; im.replaceWith(o); } else im.loading = 'eager';
        });
        bsColors.innerHTML = '';
        bsColors.appendChild(c);
        bsColors.__sig = sig;
      }
      bsColors.hidden = false;
      if (bsColors.previousElementSibling) bsColors.previousElementSibling.hidden = false;
    }
    function paintBs() {
      if (!BS) return;
      if (bs && !bs.hidden) paintBsColors();
      var branches = BS.b || [];
      var v = bsTarget();
      var size = v && sizeIndex > -1 ? sel[sizeIndex] : null;
      var pool = bsPool(v);
      var where = [];
      branches.forEach(function (br) {
        if (pool.some(function (x) { return bsQty(x.id, br.id) > 0; })) where.push(bsPlace(br.n));
      });
      if (bsLine) {
        var col = size && bsOneSize ? bsColor() : '';
        var pre = col ? (T.bsColor || '').replace('{c}', col) + ' ' : size ? (T.bsSize || '').replace('{s}', size) + ' ' : '';
        var txt;
        if (!where.length) txt = size && !col ? pre + T.bsNoneSize : pre + T.bsNone;
        else if (where.length === branches.length && branches.length > 1) txt = pre + T.bsIn + ' ' + (branches.length === 2 ? T.bsAll2 : T.bsAll);
        else txt = pre + T.bsIn + ' ' + bsJoin(where);
        bsLine.textContent = txt;
        bsLine.setAttribute('data-state', where.length ? 'in' : 'out');
      }
      if (!bs) return;
      each(bs.querySelectorAll('[data-bs-size]'), function (b) {
        var val = b.getAttribute('data-bs-size');
        var vv = null;
        for (var k = 0; k < variants.length; k++) {
          if (variants[k].o[sizeIndex] === val && matches(variants[k], sizeIndex)) { vv = variants[k]; break; }
        }
        b.hidden = !vv;
        b.classList.toggle('is-soldout', !(vv && branches.some(function (br) { return bsQty(vv.id, br.id) > 0; })));
        var on = !!size && val === size;
        b.classList.toggle('is-sel', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      each(bs.querySelectorAll('[data-bs-loc]'), function (li) {
        var loc = li.getAttribute('data-bs-loc');
        var st = li.querySelector('[data-bs-st]');
        var szs = li.querySelector('[data-bs-szs]');
        var state, label;
        if (v) {
          var q = bsQty(v.id, loc);
          state = q > 2 ? 'in' : q > 0 ? 'low' : 'out';
          label = q > 2 ? T.bsIn : q === 1 ? T.bsOne : q > 0 ? T.bsLow : T.bsOut;
          if (szs) szs.hidden = true;
        } else {
          var list = [];
          pool.forEach(function (x) { if (bsQty(x.id, loc) > 0 && sizeIndex > -1) list.push(x.o[sizeIndex]); });
          var any = pool.some(function (x) { return bsQty(x.id, loc) > 0; });
          state = any ? 'in' : 'out';
          label = any ? T.bsIn : T.bsOut;
          if (szs) {
            szs.hidden = !list.length;
            if (list.length) szs.textContent = T.bsSizes + ' ' + list.join(' · ');
          }
        }
        li.setAttribute('data-state', state);
        if (st) {
          st.setAttribute('data-state', state);
          st.querySelector('span').textContent = label;
        }
      });
    }
    /* a size tapped in the panel is the size chosen on the page */
    function pickSize(val) {
      var o = optEl(sizeIndex);
      if (!o) return;
      var hit = null;
      each(o.querySelectorAll('[data-value]'), function (x) { if (x.getAttribute('data-value') === val) hit = x; });
      if (hit) hit.click();
    }
    /* fresh numbers straight from the store (never a cached copy) */
    function refreshBs() {
      if (!BS || !BS.url) return;
      var seq = ++bsSeq;
      var u;
      try { u = new URL(BS.url, location.href); } catch (e) { return; }
      u.searchParams.set('_', String(Date.now()));
      var pt = new URLSearchParams(location.search).get('preview_theme_id');
      if (pt) u.searchParams.set('preview_theme_id', pt);
      if (bs) bs.classList.add('is-loading');
      fetch(u.href, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function (j) { if (seq === bsSeq && j && typeof j === 'object') { BS.v = j; paintBs(); } })
        .catch(function () {})
        .then(function () { if (seq === bsSeq && bs) bs.classList.remove('is-loading'); });
    }
    function openBs(opener, instant) {
      bsOpener = opener || null;
      bs.hidden = false;
      paintBs();
      try { window.history.pushState({ tsBs: 1 }, ''); } catch (e) {}
      document.documentElement.classList.add('ts-sg-open');
      if (instant) {
        var p = bs.querySelector('.ts-sg__panel'), ov = bs.querySelector('.ts-sg__overlay');
        if (p) p.style.transition = 'none';
        if (ov) ov.style.transition = 'none';
        bs.classList.add('is-open');
        raf(function () { raf(function () { if (p) p.style.transition = ''; if (ov) ov.style.transition = ''; }); });
      } else {
        raf(function () {
          raf(function () {
            bs.classList.add('is-open');
            var c = bs.querySelector('.ts-sg__close');
            if (c) c.focus({ preventScroll: true });
          });
        });
      }
      refreshBs();
    }
    function closeBs(fromHistory) {
      if (!bs || bs.hidden) return;
      if (fromHistory !== true && window.history.state && window.history.state.tsBs) { window.history.back(); return; }
      bs.classList.remove('is-open');
      document.documentElement.classList.remove('ts-sg-open');
      setTimeout(function () { bs.hidden = true; }, 350);
      if (bsOpener) bsOpener.focus({ preventScroll: true });
    }
    /* the line under the button is checked once more shortly after the page settles */
    if (BS) {
      var bsIdle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500); };
      bsIdle(function () { refreshBs(); });
    }

    /* ---------- free shipping line follows the bag ---------- */
    var shipLine = root.querySelector('[data-ship-line]');
    function paintShip(total, count) {
      if (!shipLine) return;
      var free = +shipLine.getAttribute('data-free') || 0;
      if (!count || !free) { shipLine.textContent = shipLine.getAttribute('data-default'); return; }
      var gap = free - total;
      if (gap <= 0) { shipLine.textContent = T.shipFree; return; }
      var ils = Math.ceil(gap / 100) === gap / 100 ? String(gap / 100) : (gap / 100).toFixed(2);
      var parts = (T.shipLeft || '').split('{x}');
      shipLine.innerHTML = '';
      shipLine.appendChild(document.createTextNode(parts[0] || ''));
      var b = document.createElement('b');
      b.className = 'ts-money';
      b.textContent = ils + '₪';
      shipLine.appendChild(b);
      shipLine.appendChild(document.createTextNode(parts[1] || ''));
    }
    function refreshShip() {
      if (!shipLine) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { paintShip(c.total_price, c.item_count); })
        .catch(function () {});
    }
    document.addEventListener('on:cart:after-merge', refreshShip, L);

    /* ---------- add to bag ---------- */
    /* one tap = one unit: from the tap until the bag is open, both buttons (on the page and in the sticky bar)
       show a spinner and ignore more taps, so a slow phone network never adds the same piece twice */
    var busy = false, addedTimer = 0, barErrTimer = 0;
    function setBusy(on) {
      [atc, barBtn].forEach(function (b) {
        if (!b) return;
        b.classList.toggle('is-loading', on);
        if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
      });
    }
    function setAdded() {
      clearTimeout(addedTimer);
      atc.classList.add('is-added');
      atcTxt.textContent = T.added;
      if (barBtn) { barBtn.classList.add('is-added'); barBtn.textContent = T.added; }
      addedTimer = setTimeout(function () {
        atc.classList.remove('is-added');
        if (barBtn) barBtn.classList.remove('is-added');
        update();
      }, 1800);
    }
    function barShown() { return !!bar && bar.classList.contains('is-in'); }
    function hideBarErr() { clearTimeout(barErrTimer); if (barErr) barErr.hidden = true; }
    function showBarErr(msg) {
      if (!barErr) return;
      barErr.textContent = msg || T.error;
      barErr.hidden = false;
      clearTimeout(barErrTimer);
      barErrTimer = setTimeout(hideBarErr, 6000);
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        if (missing() > -1) { nudge(); return; }
        if (!atc || atc.disabled) return;
        if (atc.getAttribute('data-state') === 'notify') { notify(); return; }
        hideErr();
        hideBarErr();
        busy = true;
        setBusy(true);

        var fd = new FormData(form);
        var secs = ['page-header', 'cart-drawer'].map(function (q) { return document.querySelector(q); }).filter(function (el) { return el && el.dataset && el.dataset.sectionId; });
        if (secs.length) {
          fd.append('sections', secs.map(function (el) { return el.dataset.sectionId; }).join(','));
          fd.append('sections_url', window.location.pathname);
        }
        var url = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add';
        /* a request that hangs on a weak signal gives up after 15 seconds instead of leaving the button spinning */
        var stop = typeof AbortController === 'function' ? new AbortController() : null;
        var stopTimer = stop ? setTimeout(function () { stop.abort(); }, 15000) : 0;

        fetch(url, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd,
          signal: stop ? stop.signal : undefined
        })
          /* a busy store can answer with a bot check page instead of JSON: that is a plain "try again", never raw text */
          .then(function (res) { return res.json().catch(function () { return null; }).then(function (j) { return { ok: res.ok, j: j }; }); })
          .then(function (r) {
            clearTimeout(stopTimer);
            var j = r.j;
            if (!r.ok || !j || j.status) {
              var cartErr = new Error(j && typeof j.description === 'string' ? j.description : '');
              cartErr.fromCart = true;
              throw cartErr;
            }
            var updated = false;
            if (j.sections) {
              secs.forEach(function (el) {
                var html = j.sections[el.dataset.sectionId];
                if (html && typeof el.updateFromCartChange === 'function') { el.updateFromCartChange(html); updated = true; }
              });
            }
            if (!updated) document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));

            setBusy(false);
            setAdded();

            var after = window.theme && window.theme.settings ? window.theme.settings.afterAddToCart : 'drawer';
            if (after === 'page') {
              window.location.href = (window.theme.routes && window.theme.routes.cart) || '/cart';
            } else {
              var drawer = document.querySelector('.js-cart-drawer');
              if (drawer && typeof drawer.open === 'function') drawer.open(barShown() ? barBtn : atc);
            }
            form.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: j.variant_id || j.id } }));
            refreshShip();
            /* the bag is sliding in: a second tap that lands on the button in the meantime is not a second unit */
            setTimeout(function () { busy = false; }, 700);
          })
          .catch(function (err) {
            clearTimeout(stopTimer);
            setBusy(false);
            /* only the store's own message (sold out, no more in stock) is shown as is; anything else gets the short Hebrew line */
            var msg = err && err.fromCart && err.message && !/[<{]/.test(err.message) ? err.message : T.error;
            showErr(msg);
            if (barShown()) showBarErr(msg);
            form.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
            busy = false;
          });
      });
    }

    /* ---------- sticky bar ---------- */
    var bar = root.querySelector('[data-bar]');
    var barBtn = null, barPrice = null, barSize = null, barErr = null;
    if (bar) {
      document.body.appendChild(bar);
      bar.hidden = false;
      bar.setAttribute('aria-hidden', 'true');
      bar.inert = true;
      barBtn = bar.querySelector('[data-bar-btn]');
      barPrice = bar.querySelector('[data-bar-price]');
      barSize = bar.querySelector('[data-bar-size]');
      barErr = document.createElement('p');
      barErr.className = 'ts-pdp-bar__err';
      barErr.setAttribute('role', 'alert');
      barErr.hidden = true;
      bar.insertBefore(barErr, bar.firstChild);
      barBtn.addEventListener('click', function () {
        if (busy) return;
        if (missing() > -1) { nudge(); return; }
        if (!form || !atc || atc.disabled) return;
        if (atc.getAttribute('data-state') === 'notify') { notify(); return; }
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
      var pastBuy = false, footerIn = false;
      var setBar = function () {
        var on = pastBuy && !footerIn;
        bar.classList.toggle('is-in', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        bar.inert = !on;
      };
      if ('IntersectionObserver' in window && buyRow) {
        var footer = document.getElementById('pagefooter');
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.target === buyRow) pastBuy = !en.isIntersecting && en.boundingClientRect.top < 0;
            else footerIn = en.isIntersecting;
          });
          setBar();
        });
        io.observe(buyRow);
        if (footer) io.observe(footer);
      }
      /* a jump straight back to the top (status bar tap, Home key) never crosses the button, so check on scroll too */
      if (buyRow) {
        var barTick = false;
        window.addEventListener('scroll', function () {
          if (barTick) return;
          barTick = true;
          raf(function () {
            barTick = false;
            var was = pastBuy;
            pastBuy = buyRow.getBoundingClientRect().bottom < 0;
            if (was !== pastBuy) setBar();
          });
        }, LP);
      }
    }
    function syncBar(state) {
      if (!bar) return;
      if (barBtn.classList.contains('is-added')) return;
      barBtn.textContent = label(state);
      barBtn.setAttribute('data-state', state);
      barBtn.disabled = state === 'soldout' || state === 'unavailable';
      if (barPrice && priceNow) barPrice.innerHTML = priceNow.innerHTML;
      if (barSize) barSize.textContent = sizeIndex > -1 && sel[sizeIndex] ? sel[sizeIndex] : '';
    }

    /* ---------- gallery ---------- */
    var track = root.querySelector('[data-track]');
    var allSlides = track ? Array.prototype.slice.call(track.children) : [];
    var slides = allSlides.filter(function (f) { return !f.hidden; });
    var colorIndex = track ? +(track.getAttribute('data-color-index') || -1) : -1;
    var byColour = colorIndex > -1 && allSlides.some(function (f) { return f.hasAttribute('data-color'); });
    var barImg = document.querySelector('.ts-pdp-bar__img');
    var prog = root.querySelector('[data-progress]');
    var progBar = prog ? prog.firstElementChild : null;
    var countEl = root.querySelector('[data-count]');

    function step() {
      if (!slides.length) return 1;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }
    function visible() { return mqDesk.matches ? slides.length : (mqTab.matches ? 2 : 1); }
    function index() { return Math.round(Math.abs(track.scrollLeft) / step()); }
    function paintProgress() {
      if (!progBar || !slides.length) return;
      var v = Math.min(visible(), slides.length);
      progBar.style.setProperty('--n', slides.length);
      progBar.style.setProperty('--v', v);
      progBar.style.setProperty('--i', Math.min(index(), slides.length - v));
      if (countEl) countEl.textContent = Math.min(index() + 1, slides.length) + '/' + slides.length;
    }
    if (track && prog) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        raf(function () { ticking = false; paintProgress(); });
      }, { passive: true });
      window.addEventListener('resize', paintProgress, L);
      paintProgress();
    }

    function goToMedia(id, smooth) {
      var idx = -1;
      for (var k = 0; k < slides.length; k++) if (String(slides[k].getAttribute('data-media-id')) === String(id)) { idx = k; break; }
      if (idx < 0 || mqDesk.matches || !track) return;
      track.scrollTo({ left: (RTL ? -1 : 1) * idx * step(), behavior: smooth ? 'smooth' : 'auto' });
    }

    /* only the chosen colour's photos (data-color on each photo, from custom.media_colors or the photo's alt);
       photos with no colour show with every colour. The page never jumps down: the new colour starts at the top. */
    function showColour(colour, user) {
      if (!byColour || colour == null) return false;
      var want = allSlides.filter(function (f) { var c = f.getAttribute('data-color'); return !c || c === colour; });
      if (!want.some(function (f) { return f.hasAttribute('data-color'); })) want = allSlides;
      var same = want.length === slides.length && want.every(function (f, k) { return f === slides[k]; });
      if (!same) {
        allSlides.forEach(function (f) { f.hidden = want.indexOf(f) < 0; });
        slides = want;
        track.classList.toggle('is-single', slides.length === 1);
        zoomList();
        each(slides.slice(0, 2), function (f) { var im = f.querySelector('img[loading="lazy"]'); if (im) im.loading = 'eager'; });
      }
      if (user) {
        track.scrollLeft = 0;
        if (mqDesk.matches) {
          var top = track.getBoundingClientRect().top;
          if (top < hdr()) window.scrollTo({ top: Math.max(0, window.pageYOffset + top - hdr() - 24), behavior: 'smooth' });
        }
      }
      var first = slides[0] && slides[0].querySelector('img');
      if (barImg && first) barImg.src = (first.currentSrc || first.src).replace(/([?&])width=\d+/, '$1width=120');
      paintProgress();
      return true;
    }

    /* ---------- full screen photos ---------- */
    var zoomBtns = [], srcs = [];
    function zoomList() {
      zoomBtns = [];
      slides.forEach(function (f) { var b = f.querySelector('[data-zoom]'); if (b) zoomBtns.push(b); });
      srcs = zoomBtns.map(function (b) { return b.getAttribute('data-zoom-src'); });
    }
    zoomList();
    var lb = null, lbTrack = null, lbCount = null, lbPrev = null, lbNext = null, lbOpener = null;

    function lbIndex() { return lbTrack ? Math.round(Math.abs(lbTrack.scrollLeft) / (lbTrack.clientWidth || 1)) : 0; }
    function lbPaint() {
      if (!lb) return;
      var i = lbIndex();
      lbCount.textContent = (i + 1) + '/' + srcs.length;
      lbPrev.disabled = i <= 0;
      lbNext.disabled = i >= srcs.length - 1;
    }
    function lbUnzoom() {
      each(lb.querySelectorAll('.ts-lb__slide.is-zoom'), function (s) { s.classList.remove('is-zoom'); });
    }
    function lbStep(dir) {
      lbUnzoom();
      lbTrack.scrollBy({ left: (RTL ? -1 : 1) * dir * lbTrack.clientWidth, behavior: 'smooth' });
    }
    function buildLb() {
      lb = document.createElement('div');
      lb.className = 'ts-lb';
      lb.hidden = true;
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', T.gallery || '');
      lb.innerHTML =
        '<button type="button" class="ts-lb__close" aria-label="' + (T.close || '') + '">' + ICON_X + '</button>' +
        '<p class="ts-lb__count" aria-live="polite"></p>' +
        '<button type="button" class="ts-lb__nav ts-lb__nav--prev" aria-label="' + (T.prev || '') + '">' + (RTL ? ICON_R : ICON_L) + '</button>' +
        '<button type="button" class="ts-lb__nav ts-lb__nav--next" aria-label="' + (T.next || '') + '">' + (RTL ? ICON_L : ICON_R) + '</button>' +
        '<div class="ts-lb__track"></div>';
      document.body.appendChild(lb);
      lbTrack = lb.querySelector('.ts-lb__track');
      lbCount = lb.querySelector('.ts-lb__count');
      lbPrev = lb.querySelector('.ts-lb__nav--prev');
      lbNext = lb.querySelector('.ts-lb__nav--next');
      lb.querySelector('.ts-lb__close').addEventListener('click', closeLb);
      lbPrev.addEventListener('click', function () { lbStep(-1); });
      lbNext.addEventListener('click', function () { lbStep(1); });
      var t = false;
      lbTrack.addEventListener('scroll', function () {
        if (t) return;
        t = true;
        raf(function () { t = false; lbPaint(); });
      }, { passive: true });
      var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      lbTrack.addEventListener('click', function (e) {
        if (!fine.matches) return;
        var slide = e.target.closest('.ts-lb__slide');
        if (!slide) return;
        var img = slide.querySelector('img');
        var r = slide.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        slide.classList.toggle('is-zoom');
      });
      lbTrack.addEventListener('mousemove', function (e) {
        var slide = e.target.closest('.ts-lb__slide.is-zoom');
        if (!slide) return;
        var r = slide.getBoundingClientRect();
        slide.querySelector('img').style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      document.addEventListener('keydown', function (e) {
        if (!lb || lb.hidden) return;
        if (e.key === 'Escape') { e.preventDefault(); closeLb(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); lbStep(RTL ? 1 : -1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); lbStep(RTL ? -1 : 1); }
      }, L);
    }
    function openLb(i, opener) {
      if (!srcs.length) return;
      if (!lb) buildLb();
      lbOpener = opener || null;
      var alt = (root.querySelector('.ts-pdp__title') || {}).textContent || '';
      lbTrack.innerHTML = srcs.map(function (src, k) {
        return '<div class="ts-lb__slide"><img src="' + src + '" alt="' + alt.replace(/"/g, '') + ' ' + (k + 1) + '" decoding="async"' + (Math.abs(k - i) > 1 ? ' loading="lazy"' : '') + '></div>';
      }).join('');
      lb.hidden = false;
      document.documentElement.classList.add('ts-lb-open');
      lbTrack.scrollLeft = (RTL ? -1 : 1) * i * lbTrack.clientWidth;
      lbPaint();
      raf(function () {
        lb.classList.add('is-open');
        lbTrack.scrollLeft = (RTL ? -1 : 1) * i * lbTrack.clientWidth;
        lbPaint();
        lb.querySelector('.ts-lb__close').focus({ preventScroll: true });
      });
    }
    function closeLb() {
      if (!lb || lb.hidden) return;
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('ts-lb-open');
      setTimeout(function () {
        lb.hidden = true;
        lbTrack.innerHTML = '';
      }, 220);
      if (lbOpener) lbOpener.focus({ preventScroll: true });
    }
    each(root.querySelectorAll('[data-zoom]'), function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        openLb(Math.max(0, zoomBtns.indexOf(b)), b);
      });
    });

    /* ---------- desktop: details column follows the photos ---------- */
    function placeInfo() {
      if (!info) return;
      if (!mqDesk.matches) { info.style.top = ''; return; }
      var h = info.offsetHeight;
      var top = hdr() + 24;
      if (h + top + 24 > window.innerHeight) top = window.innerHeight - h - 32;
      info.style.top = top + 'px';
    }
    if (info) {
      placeInfo();
      window.addEventListener('resize', placeInfo, L);
      if ('ResizeObserver' in window) { ro = new ResizeObserver(placeInfo); ro.observe(info); }
      if (mqDesk.addEventListener) mqDesk.addEventListener('change', function () { placeInfo(); paintProgress(); }, L);
    }

    /* ---------- Tellos video carousel: start from the right like the rest of the page ---------- */
    if (RTL && root.querySelector('.ts-pdp__app')) {
      var tl = 0;
      (function tellos() {
        var sw = root.querySelector('.ts-pdp__app swiper-container');
        if (sw && sw.swiper && typeof sw.swiper.changeLanguageDirection === 'function') {
          if (!sw.swiper.rtl) { sw.setAttribute('dir', 'rtl'); sw.swiper.changeLanguageDirection('rtl'); }
          return;
        }
        if (++tl < 40) setTimeout(tellos, 250);
      })();
    }

    /* ---------- start ---------- */
    if (sizeIndex > -1 && sel[sizeIndex] == null) {
      var want = root.__tsCarry && root.__tsCarry.size || null;
      try { var kept = sessionStorage.getItem(SIZE_KEY); sessionStorage.removeItem(SIZE_KEY); if (!want) want = kept; } catch (x) {}
      if (want) {
        var o = optEl(sizeIndex);
        var pick = null;
        if (o) each(o.querySelectorAll('[data-value]'), function (b) { if (b.getAttribute('data-value') === want) pick = b; });
        if (pick) {
          var probe = sel.slice();
          probe[sizeIndex] = want;
          for (var k = 0; k < variants.length; k++) {
            var ok = true;
            for (var i = 0; i < nOpts; i++) if (probe[i] != null && variants[k].o[i] !== probe[i]) ok = false;
            if (ok && variants[k].a) { sel[sizeIndex] = want; break; }
          }
        }
      }
    } else {
      try { sessionStorage.removeItem(SIZE_KEY); } catch (x) {}
    }
    update();
    var filtered = byColour && colorIndex < nOpts && showColour(sel[colorIndex] != null ? sel[colorIndex] : (closest() || { o: [] }).o[colorIndex], false);
    if (!filtered && data.startMedia && !mqDesk.matches) goToMedia(data.startMedia, false);
    if (bs && root.__tsCarry && root.__tsCarry.openBs) {
      openBs(root.querySelector('[data-bs-open]'), true);
      var bsBody = bs.querySelector('.ts-sg__body');
      if (bsBody && root.__tsCarry.scroll) bsBody.scrollTop = root.__tsCarry.scroll;
    }

    root.__tsVariant = function () { var v = current(); return v && missing() < 0 && nOpts ? v.id : null; };
    root.__tsDestroy = function () {
      if (ac) ac.abort();
      if (io) io.disconnect();
      if (ro) ro.disconnect();
      if (bar) bar.remove();
      if (sg) sg.remove();
      if (bs) bs.remove();
      if (lb) lb.remove();
      document.documentElement.classList.remove('ts-sg-open', 'ts-lb-open');
    };
    if (location.hash === '#ts-notify') {
      try { history.replaceState(history.state, '', location.pathname + location.search); } catch (x) {}
      if (atc && atc.getAttribute('data-state') === 'notify') notify();
    }
    if (!root.__tsCarry) prefetchSiblings(root);
  }

  function boot() {
    each(document.querySelectorAll('[data-ts-pdp]'), init);
    each(document.querySelectorAll('[data-ts-more]'), initMore);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
